<template>
	<form-table-wrapper>
		<template #form-title>
			<div class="tw-text-center">
				{{currentTab.formTitle || 'Ingreso'}}
			</div>
		</template>
		<template #form>
			<div class="tw-flex tw-mt-4 tw--mx-2">
				<template v-for="tab in tabs">
					<div
						v-if="tab.divider"
						:key="tab.name"
						class="tw-w-0.5 tw-bg-white tw-m-0 tw-my-1 tw-rounded-full"
					></div>
					<b-button
						v-else
						:key="tab.name"
						:to="tab.path"
						size="sm"
						class="tw-flex-1 tw-shadow-none tw-text-xl tw-font-bold tw-font-ws tw-mx-2"
						:variant="tab.path === $route.path ? 'primary' : 'secondary'"
					>{{ tab.name }}</b-button>
				</template>
			</div>
			<router-view name="form"></router-view>
		</template>
		<template #table-title>{{ currentTab.name || $route.name }}</template>
		<template #table>
			<router-view></router-view>
		</template>
	</form-table-wrapper>
</template>
<script>
import FormTableWrapper from './FormTableWrapper.vue';
export default {
	name: 'TabLayoutWrapper',
	components: {
		FormTableWrapper
	},
	props: {
		tabs: {
			type: Array,
			required: true
		}
	},
	computed: {
		currentTab() {
			return this.tabs.find(
				tab => tab.path === this.$route.path
			) || {}
		}
	}
};
</script>

